import React from "react";
import { TextField } from "material-ui";

import { formatPrice, parsePriceToCents } from "../../util";

/**
 * Display currency input fields in a user-friendly $xx.yy format, but serialize them
 * into cents before propagating to the parent component. A thin wrapper around
 * material-ui's <TextField/>.
 */
class CurrencyField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editedValue: null
    };

    this._extractValue = this._extractValue.bind(this);
    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
  }

  _extractValue(value) {
    let sign = this.props.allowNegative && value[0] === "-" ? -1 : 1;
    return parsePriceToCents(value) * sign;
  }

  _handleInputChange(e) {
    let { value } = e.target;

    this.setState({
      editedValue: value
    });

    this.props.onChange({
      target: {
        value: this._extractValue(value)
      }
    });
  }

  _handleInputBlur(e) {
    if (this.props.onBlur) {
      this.props.onBlur({
        target: {
          value: this._extractValue(this.state.editedValue || e.target.value)
        }
      });
    }
    this.setState({ editedValue: null });
  }

  render() {
    let { value, onChange, onBlur, placeholder, ...props } = this.props,
      { editedValue } = this.state;

    if (placeholder === "$0.00") {
      placeholder = formatPrice(
        0,
        this.props.currency ? { currency: this.props.currency } : undefined
      );
    }

    return (
      <TextField
        value={
          editedValue !== null
            ? editedValue
            : value
            ? `${formatPrice(
                value,
                this.props.currency
                  ? { currency: this.props.currency }
                  : undefined
              )}`
            : ""
        }
        onChange={this._handleInputChange}
        onBlur={this._handleInputBlur}
        placeholder={placeholder}
        {...props}
      />
    );
  }
}

export default CurrencyField;



// WEBPACK FOOTER //
// ./src/app/components/partials/currency-field.jsx